<template>
  <div>
    <Container>
      <section class="mrgb+">
        <Media>
          <MediaBody>
            <div class="flex align-items-center">
              <h1 class="h3 mrgv0">
                {{ $t('planification.title') }}
              </h1>

              <Btn
                data-cy="add-group"
                variant="primary"
                class="mrgl"
                @click="toggleGroupAddOrUpdate"
              >
                {{ $t('planification.groups.add.title') }}
              </Btn>
            </div>
          </MediaBody>

          <MediaRight v-if="loading">
            <Loader />
          </MediaRight>
        </Media>
      </section>

      <section class="mrgb+">
        <PlanificationFilters />
      </section>

      <section v-if="groups && groups.length">
        <ListStacked size="tight">
          <li v-for="(group, index) in groups" :key="index">
            <PlanificationGroup :group="group" />
          </li>
        </ListStacked>
      </section>

      <section v-else-if="!loading" class="center pdgv++">
        <h2 class="h3 mrgb+">
          <span v-if="$store.state.planification.sort.groupName">
            {{
              $t('planification.groups.no-search-groups', {
                query: $store.state.planification.sort.groupName,
              })
            }}
          </span>
          <span v-else>
            {{ $t('planification.groups.no-groups') }}
          </span>
        </h2>
        <img :src="require('@/assets/images/directory.svg')" />
      </section>

      <PlanificationGroupAddOrUpdate />
      <PlanificationGroupDelete />
      <PlanificationUserAddOrUpdate />
      <PlanificationUserDelete />
    </Container>
  </div>
</template>

<script>
import _ from 'lodash';
import eventBus from '@/eventBus';

import Loader from '@/components/ui/Loader';
import PlanificationFilters from '@/components/planification/PlanificationFilters';
import PlanificationGroup from '@/components/planification/PlanificationGroup';
import PlanificationGroupAddOrUpdate from '@/components/planification/PlanificationGroupAddOrUpdate';
import PlanificationGroupDelete from '@/components/planification/PlanificationGroupDelete';
import PlanificationUserAddOrUpdate from '@/components/planification/PlanificationUserAddOrUpdate';
import PlanificationUserDelete from '@/components/planification/PlanificationUserDelete';

export default {
  components: {
    Loader,
    PlanificationFilters,
    PlanificationGroup,
    PlanificationGroupAddOrUpdate,
    PlanificationGroupDelete,
    PlanificationUserAddOrUpdate,
    PlanificationUserDelete,
  },

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    groups() {
      const groupName = this.$store.state.planification.sort.groupName;

      return Object.values(this.$store.state.planification.index)
        .filter(group => !group.memberships.length)
        .filter(group => {
          if (groupName?.length) {
            return (
              group.name.toLowerCase().includes(groupName.toLowerCase()) ||
              this.groupIncludesGroupName(group, groupName)
            );
          }

          return group;
        });
    },
  },

  mounted() {
    this.loading = true;

    this.$store.dispatch('planification/getGroups').finally(() => {
      this.loading = false;
    });
  },

  methods: {
    toggleGroupAddOrUpdate() {
      eventBus.$emit('togglePlanificationGroupAddOrUpdate');
    },

    groupIncludesGroupName(group, name) {
      return group.members?.some(member => {
        const localGroup = this.$store.getters[
          'planification/getGroupByUsername'
        ](member.username);

        return (
          localGroup &&
          (localGroup.name.toLowerCase().includes(name.toLowerCase()) ||
            this.groupIncludesGroupName(localGroup, name))
        );
      });
    },
  },
};
</script>
